/***
 * Created on 2023/7/19
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/


import React, {useMemo, useRef, useState} from 'react';
import {useQueryClient} from "@tanstack/react-query";
import Dropdown from "../common/form/dropdown";
import {useTranslation} from "react-i18next";

const PAGE_SIZE_LIST = [10, 20, 50, 100, 150, 200];

function ContactFooter({page, setPage, total, pageSize, setPageSize}) {
    const queryClient = useQueryClient();
    const inputRef = useRef();
    const { t } = useTranslation();

    const maxSize = useMemo(()=>{
        return Math.ceil(total / pageSize);
    },[total, pageSize]);

    const onJumpToChange = (e) => {
        inputRef.current.value = e.target.value;
        jumpToPage(e.target.value);
    }

    const nextPage = () => {
        if (page < maxSize) {
            setPage(prev => {
                inputRef.current.value++;
                return prev + 1;
            })
        }
    }

    const prevPage = () => {
        if (page > 0) {
            setPage(prev => {
                inputRef.current.value--;
                return prev - 1;
            })
        }
    }

    const jumpToPage = (p) => {
        if (p <= maxSize && p-1 >= 0) {
            setPage(prev => {
                inputRef.current.value = p;
                return p-1;
            })
        }
    }

    const refresh = async () => {
        await queryClient.prefetchQuery({
            queryKey: ['friend', page, pageSize]
        })
    }

    return (
        <div className="page-footer" data-has-pagination={true}>
            <div className="comp-pagination h-100">
                <div className="pagination--table !h-100">
                    <div className="pagination__col mr-auto">
                        <div className={`pagination__btn cursor-pointer ${page <= 0 ? 'disabled' : ''}`} data-pgnt-btn="front" onClick={()=>jumpToPage(1)}/>
                        <div className={`pagination__btn cursor-pointer ${page <= 0 ? 'disabled' : ''}`} data-pgnt-btn="prev" onClick={prevPage} />
                        <div className="pagination__divide" />
                        <div className="pagination__text mr-10">{t('@Page@')}</div>
                        <input type="text" defaultValue={1} onChange={onJumpToChange} ref={inputRef}/>
                        <div className="pagination__text ml-10">/ {maxSize || '-'}</div>
                        <div className="pagination__divide" />
                        <div className={`pagination__btn cursor-pointer ${page+1 >= maxSize ? 'disabled' : ''}`} data-pgnt-btn="next" onClick={nextPage}/>
                        <div className={`pagination__btn cursor-pointer ${page+1 >= maxSize ? 'disabled' : ''}`} data-pgnt-btn="last" onClick={()=>jumpToPage(maxSize)}/>
                        <div className="pagination__divide" />
                        <div className="pagination__btn cursor-pointer" data-pgnt-btn="refresh" onClick={refresh}/>
                    </div>
                    <div className="pagination__col ml-auto">
                        <div className="pagination__text mr-10">{t('@Show@')}</div>
                        <Dropdown initValue={pageSize} data={PAGE_SIZE_LIST} onClick={(e, item)=>setPageSize(item)} align={"top"}/>
                        <div className="pagination__text-page ml-10">{t('@Items per page@')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactFooter;